/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { MenuItem } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// custom Import component
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
// custom import function
import {
  radioGroupLabelNamePlan,
  rebateProgramLabelName,
  quarterLabelName,
} from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  checkQuarterValidation,
  handleScrollToEvent,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  setGenerateInvoiceSearchTab,
  getQuarterData,
  getResumeInvoicePrintList,
  dispatchUpdateCustomizeLetter,
  setPervSearchScreenTabDataRedux,
  setGenerateInvoiceDetailTab,
  getSearchGenerateInvByCriteriaList,
  getPlanTypeRadioBoxValue,
  handleErrorMesGenerateInvInRedux,
  dispatchGenerateInvoiceCriteriaList,
  getCommonDropdownList,
} from '../store/Actions';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';

function GenerateInvoiceSearchCom() {
  const dispatch = useDispatch();
  const history = useHistory();
  // use Selector function

  const searchScreenTabData = useSelector(
    (state) => state.sharedState.GenerateInvoiceReducer?.generateInvoiceTabObj
  );
  const getQuarterDataValue = useSelector(
    (state) => state.sharedState.GenerateInvoiceReducer.quarter
  );
  const getPlanTypeData = useSelector(
    (state) => state.sharedState.GenerateInvoiceReducer?.planTypeRadioList
  );
  const perviousGenerateInvGridList = useSelector(
    (state) =>
      state.sharedState.GenerateInvoiceReducer?.perviousSearchScreenDataRedux
        ?.generateInvoiceGridVOList
  );
  const errorMessagesFromRedux = useSelector(
    (state) => state?.sharedState?.GenerateInvoiceReducer?.errorMessagesInRedux
  );
  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );
  const generateInvoiceGridData = useSelector((state) =>
    state.sharedState.GenerateInvoiceReducer?.generateInvoiceGridVOList?.sort(
      (a, b) => a.cfSortKey - b.cfSortKey
    )
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  // variable deceleration
  const [planTypeOptions, setPlanTypeOptions] = useState([]);
  const [rebateProgramList, setRebateProgramList] = useState([]);
  const [state, setState] = useState(
    searchScreenTabData?.state
      ? searchScreenTabData.state
      : {
          planTypeCd: UserDefaultValues?.planTypeCd
            ? UserDefaultValues?.planTypeCd
            : 'FD',
          rebateProgramCd: UserDefaultValues?.rebateProgramCd
            ? UserDefaultValues?.rebateProgramCd
            : '-1',
          quarterValue: null,
          isResumePrinting: false,
        }
  );
  const [commonDropdownList, setCommonDropdownList] = React.useState([]);

  const formatQuarterInput = (value) => {
    if (value == null || value === '' || typeof value === 'object') {
      return value;
    }
    return autoFormateDate(String(value).toUpperCase());
  };

  // handling onPage load call service
  React.useEffect(() => {
    handleScrollToEvent();
    if (searchScreenTabData && Object.keys(searchScreenTabData)?.length === 0) {
      dispatch(
        handleErrorMesGenerateInvInRedux({
          searchScreenErrors: [],
          detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
            ? errorMessagesFromRedux?.detailScreenErrors
            : [],
        })
      );
      dispatch(getQuarterData());
      if (!getPlanTypeData?.PLAN_TYPE_CD) {
        dispatch(getPlanTypeRadioBoxValue());
      }
    }
  }, []);
  // set play type Radio Data List for page load
  React.useEffect(() => {
    const planList =
      getPlanTypeData?.PLAN_TYPE_CD?.length > 0 &&
      getPlanTypeData?.PLAN_TYPE_CD?.map((obj) => {
        return {
          name:
            obj?.codeValueID?.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
    setPlanTypeOptions(planList);
  }, [getPlanTypeData]);
  // set common dropdown list after calling API service
  React.useEffect(() => {
    getCommonDropdownList(state.planTypeCd).then((res) => {
      setCommonDropdownList(res);
    });
  }, [state.planTypeCd]);
  // set Rebate Program List after calling API service
  React.useEffect(() => {
    let list = [];
    if (
      commonDropdownList?.status === constantMessageData.STATUS_MSG &&
      commonDropdownList?.message === constantMessageData.SUCCESS_MSG
    ) {
      if (!_.isEmpty(commonDropdownList.data)) {
        list = _.map(commonDropdownList.data, (val) => ({
          ...val,
          id: val.rebateProgramCd,
          name: `${val.rebateProgramCd} | ${val.shortDescr}`,
        }));
      }
    }
    setRebateProgramList(
      list.sort((key, val) =>
        key.name.toLowerCase().localeCompare(val.name.toLowerCase())
      )
    );
  }, [commonDropdownList]);
  // set initial quarte Value
  React.useEffect(() => {
    if (Object.keys(searchScreenTabData)?.length === 0) {
      if (
        getQuarterDataValue &&
        typeof getQuarterDataValue !== 'object' &&
        !searchScreenTabData?.state?.quarterValue
      ) {
        const formattedQuarter = formatQuarterInput(getQuarterDataValue);
        setState({
          ...state,
          quarterValue: formattedQuarter,
        });
        dispatch(
          setGenerateInvoiceSearchTab({
            ...searchScreenTabData,
            state: {
              ...state,
              quarterValue: formattedQuarter,
            },
          })
        );
      }
    }
  }, [getQuarterDataValue]);
  // handing highlight tab
  React.useEffect(() => {
    if (
      errorMessagesFromRedux?.searchScreenErrors &&
      errorMessagesFromRedux?.searchScreenErrors.length > 0
    ) {
      tabHighLigther('/generateInvoice', true);
    } else {
      tabHighLigther('/generateInvoice', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);
  // handing On change event on filed level
  const handleOnChangeEvent = (value, name) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    if (name === 'planTypeCd') {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
      );
      setState({ ...state, [name]: value, rebateProgramCd: '-1' });
      dispatch(
        setGenerateInvoiceSearchTab({
          ...searchScreenTabData,
          state: { ...state, [name]: value, rebateProgramCd: '-1' },
        })
      );
    } else {
      setState({ ...state, [name]: value });
      dispatch(
        setGenerateInvoiceSearchTab({
          ...searchScreenTabData,
          state: { ...state, [name]: value },
        })
      );
    }
    dispatch(
      handleErrorMesGenerateInvInRedux({
        searchScreenErrors: [...new Set(localErr)],
        detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
          ? errorMessagesFromRedux?.detailScreenErrors
          : [],
      })
    );
  };
  //  hading On blur event on filed level
  const handleOnblurEvent = (type, value) => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
        );
      }
    }
    if (type === 'quarter') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        localErr = localErr?.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        if (checkQuarterValidation(value)) {
          localErr = localErr?.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );
          setState({
            ...state,
            quarterValue: autoFormateDate(value?.toUpperCase()),
          });
          dispatch(
            setGenerateInvoiceSearchTab({
              ...searchScreenTabData,
              state: {
                ...state,
                quarterValue: autoFormateDate(value?.toUpperCase()),
              },
            })
          );
        } else {
          localErr = localErr.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
          });
        }
      } else {
        localErr = localErr.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
      }
    }
    dispatch(
      handleErrorMesGenerateInvInRedux({
        searchScreenErrors: [...new Set(localErr)],
        detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
          ? errorMessagesFromRedux?.detailScreenErrors
          : [],
      })
    );
  };

  // click on search  Button after redirect Generate Invoice Detail screen
  const handleGenerateInvoiceDetailForSearch = async () => {
    let localErr = errorMessagesFromRedux?.searchScreenErrors || [];
    if (
      state?.rebateProgramCd !== null &&
      state?.rebateProgramCd !== '-1' &&
      checkQuarterValidation(state.quarterValue)
    ) {
      const response = await dispatch(
        getSearchGenerateInvByCriteriaList({
          rebateProgramCd: state?.rebateProgramCd,
          qtr: state?.quarterValue,
          planTypeCd: state?.planTypeCd,
          includeCreated: 0,
          includeNonRequested: 0,
          includeUploaded: 0,
          includePrinted: 1,
          includeMailed: 0,
          includeNotCreated: 0,
          action: 0,
        })
      );
      if (response?.generateInvoiceGridVOList?.length >= 0) {
        dispatch(
          setPervSearchScreenTabDataRedux({
            state: state,
            generateInvoiceGridVOList: response?.generateInvoiceGridVOList,
          })
        );
        dispatch(setGenerateInvoiceDetailTab({}));
        dispatch(dispatchUpdateCustomizeLetter(''));
        localErr = localErr.filter((item) => item.field !== 'resultNotFound');
        redirectURLLink(
          '/generateInvoiceDetail',
          'Generate Invoice Detail',
          history,
          dispatch
        );
      } else {
        dispatch(
          dispatchGenerateInvoiceCriteriaList(perviousGenerateInvGridList)
        );
        // localErr.push({
        //   field: 'resultNotFound',
        //   errorType: 'resultNotFound',
        //   message: constantMessageData.MNFC_NDC_ERROR_MSG,
        // });
        // handleScrollToEvent();
      }
    } else if (
      state.rebateProgramCd === null ||
      state.rebateProgramCd === '-1'
    ) {
      localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED,
      });
    } else if (state.quarterValue === '') {
      localErr = localErr.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: constantMessageData.QUARTER_VALUE_REQUIRED,
      });
    } else if (!checkQuarterValidation(state.quarterValue)) {
      localErr = localErr.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'invalidFormat',
        message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
      });
    }
    if (localErr && !localErr.length > 0) {
      tabHighLigther('/generateInvoice', false);
    }
    dispatch(
      handleErrorMesGenerateInvInRedux({
        searchScreenErrors: [...new Set(localErr)],
        detailScreenErrors: errorMessagesFromRedux?.detailScreenErrors
          ? errorMessagesFromRedux?.detailScreenErrors
          : [],
      })
    );
  };
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  // click on Resume Button after redirect Generate Invoice Detail screen
  const handleGenerateInvoiceDetailForResume = () => {
    dispatch(
      setPervSearchScreenTabDataRedux({
        state: state,
        generateInvoiceGridVOList: generateInvoiceGridData,
      })
    );
    dispatch(setGenerateInvoiceDetailTab({}));
    dispatch(dispatchGenerateInvoiceCriteriaList([]));
    dispatch(
      getResumeInvoicePrintList({
        userId: UserDefaultValues?.userId
          ? UserDefaultValues?.userId
          : logInUser,
      })
    );
    redirectURLLink(
      '/generateInvoiceDetail',
      'Generate Invoice Detail',
      history,
      dispatch
    );
    dispatch(
      handleErrorMesGenerateInvInRedux({
        searchScreenErrors: [],
        detailScreenErrors: [],
      })
    );
  };
  return (
    <div className='tabs-container' data-testid='generate-invoice-component'>
      <CustomSeparator parent1='Invoice' parent2='Generate Invoice' />
      {!state?.isResumePrinting && (
        <DisplayErrorMessages
          errorMessages={[
            ...new Set(
              errorMessagesFromRedux?.searchScreenErrors?.length > 0
                ? _.map(
                    errorMessagesFromRedux.searchScreenErrors,
                    (l) => l.message
                  )
                : []
            ),
          ]}
        />
      )}
      <Spinner load={spinnerLoader} />
      {!state?.isResumePrinting && (
        <div className='row align-item-center frr-generate-invoice'>
          <div className='col-12 col-sm-7 col-md-5 frr-radio-40per-width'>
            <RadioGroupComponent
              data-testid='filter-plan-by-radio-btn-plan'
              id='filter-plan-by-radio-btn-action'
              labelName={radioGroupLabelNamePlan}
              required
              reqColor
              optionList={planTypeOptions}
              defaultValue={state && state.planTypeCd}
              filterAction={(e) => {
                handleOnChangeEvent(e, 'planTypeCd');
              }}
              className='log-batch-filter-radio frr-checkInvoiceRadio'
            />
          </div>
          <div className='col-12 col-sm-5 col-md-7 frr-checkInvoiceRebate'>
            <div className='mt-2'>
              <fieldset className='custom-fieldset'>
                <legend aria-hidden='true' className='d-none' />
                <div className='form-wrapper my-2'>
                  <div className='mui-custom-form with-select'>
                    <TextField
                      data-testid='rebate_program-generate-inv'
                      id='rebate_program'
                      label={rebateProgramLabelName}
                      fullWidth
                      select
                      required
                      placeholder=''
                      inputProps={{ maxLength: 11, id: 'rebate_program' }}
                      onBlur={(e) =>
                        handleOnblurEvent('rebateProgramCd', e.target.value)
                      }
                      InputLabelProps={{ shrink: true }}
                      value={state && state.rebateProgramCd}
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                      }
                      className={
                        errorMessagesFromRedux?.searchScreenErrors?.length > 0
                          ? _.map(
                              errorMessagesFromRedux.searchScreenErrors,
                              (l) =>
                                l.field === 'rebateProgramCd'
                                  ? 'mandate-fields'
                                  : null
                            )
                          : null
                      }
                      helperText={
                        errorMessagesFromRedux?.searchScreenErrors?.length > 0
                          ? _.map(
                              errorMessagesFromRedux.searchScreenErrors,
                              (l) =>
                                l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      }
                      error={
                        errorMessagesFromRedux?.searchScreenErrors?.length > 0
                          ? _.map(
                              errorMessagesFromRedux.searchScreenErrors,
                              (l) =>
                                l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      }
                    >
                      <MenuItem
                        key=''
                        value=''
                        className='frr-dropdown-blank-item'
                      >
                        {''}
                      </MenuItem>
                      {rebateProgramList?.map((item) => {
                        return (
                          <MenuItem key={item.id} value={item.id}>
                            {item.name}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </div>
                  <div className='mui-custom-form input-md frr-check-invoice-quater'>
                    <TextField
                      data-testid='check_quarter_gi'
                      id='check_by_invoice_quater'
                      required
                      label={quarterLabelName}
                      fullWidth
                      placeholder=''
                      inputProps={{ maxLength: 6 }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={state && state.quarterValue}
                      onChange={(e) => {
                        handleOnChangeEvent(e.target.value, 'quarterValue');
                      }}
                      onBlur={(e) =>
                        handleOnblurEvent('quarter', e.target.value)
                      }
                      className={
                        errorMessagesFromRedux?.searchScreenErrors?.length > 0
                          ? _.map(
                              errorMessagesFromRedux.searchScreenErrors,
                              (l) =>
                                l.field === 'quarter' ? 'mandate-fields' : null
                            )
                          : null
                      }
                      helperText={[
                        ...new Set(
                          errorMessagesFromRedux?.searchScreenErrors?.length > 0
                            ? _.map(
                                errorMessagesFromRedux.searchScreenErrors,
                                (l) =>
                                  l.field === 'quarter' ? l.message : null
                              )
                            : null
                        ),
                      ]}
                      error={[
                        ...new Set(
                          errorMessagesFromRedux?.searchScreenErrors?.length > 0
                            ? _.map(
                                errorMessagesFromRedux.searchScreenErrors,
                                (l) =>
                                  l.field === 'quarter' ? l.message : null
                              )
                            : null
                        ),
                      ]}
                    />
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      )}
      <div className='row'>
        <div className='col-4 pl-0'>
          <div className='mui-custom-form input-md frr-no-wrap'>
            <FormControlLabel
              className='frr-mt-26 ml-2'
              control={<Checkbox color='primary' />}
              label='Resume Printing'
              data-testid='isResumePrinting'
              value={state.isResumePrinting}
              checked={state.isResumePrinting}
              onChange={(e) => {
                handleOnChangeEvent(e.target.checked, 'isResumePrinting');
              }}
            />
          </div>
        </div>
        {!state.isResumePrinting && (
          <div className='col-8'>
            <div className='text-right mt-4'>
              <Button
                className='btn btn-success btn-search'
                data-testid='view_detail_ia'
                type='button'
                onClick={() => handleGenerateInvoiceDetailForSearch()}
              >
                {' '}
                <SVGComponent iconName='Icon-search' /> {'  '}Search
              </Button>
            </div>
          </div>
        )}
      </div>

      {state.isResumePrinting && (
        <>
          <p>
            Resume Printing will allow you to restart printing of your
            previously selected invoices. It will allow you to designate the
            invoice at which you would like to start printing.
          </p>
          <div className='row'>
            <div className='col-12'>
              <div className='text-right'>
                <Button
                  className='btn btn-success btn-search'
                  data-testid='resume-btn'
                  type='button'
                  onClick={() => handleGenerateInvoiceDetailForResume()}
                >
                  {' '}
                  <SVGComponent iconName='Create-new-icon' /> {'  '} Resume
                </Button>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
export default GenerateInvoiceSearchCom;
